/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'delete': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M2.5 5.833a.5.5 0 01.5-.5h13.333a.5.5 0 110 1H3a.5.5 0 01-.5-.5zM8 8.667a.5.5 0 01.5.5v5a.5.5 0 01-1 0v-5a.5.5 0 01.5-.5zM11.333 8.667a.5.5 0 01.5.5v5a.5.5 0 01-1 0v-5a.5.5 0 01.5-.5z" _fill="#1F222C"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M3.792 5.335a.5.5 0 01.54.457l.833 10A1.167 1.167 0 006.333 17H13a1.167 1.167 0 001.168-1.208l.834-10a.5.5 0 11.996.083l-.832 9.98A2.167 2.167 0 0113 18H6.333a2.167 2.167 0 01-2.166-2.145l-.832-9.98a.5.5 0 01.457-.54z" _fill="#1F222C"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M8 3a.333.333 0 00-.333.333v2.5a.5.5 0 11-1 0v-2.5C6.667 2.597 7.264 2 8 2h3.333c.737 0 1.334.597 1.334 1.333v2.5a.5.5 0 11-1 0v-2.5A.333.333 0 0011.333 3H8z" _fill="#1F222C"/>'
  }
})
